import Approute from './App-route';
import { BrowserRouter as Router } from 'react-router-dom';

import './App.css';

function App() {
  return (
    <div className="App">
    {/* Add your app-wide layout components, e.g., a Header or a Sidebar here */}
    <Approute />  {/* This will handle all your routes */}
  </div>
  );
}

export default App;
